import React from 'react'

const pie_chart = () => {
  return (
    <div>pie_chart</div>
  )
}

export default pie_chart